<ui-view>
	<div [ngClass]="styles.gridLayout" [style.grid-template-columns]="rowStyle">
		<a *ngFor="let video of videos" uiSref=".play" [uiParams]="{ videoId: video.id }">
			<div class="fixed-ratio" [style.background-image]="video.thumbnailBg">
				<span *ngIf="video.duration >= 0" [ngClass]="styles.durationOverlay">
					{{ video.duration | vbTimespan }}
				</span>
			</div>
			<span>
				{{video.title}}
			</span>
		</a>
	</div>
</ui-view>
<a *ngIf="uiRouterGlobals.current.name === 'embedPlaylist.grid.play'" uiSref="embedPlaylist.grid" [ngClass]="styles.closeLink">
	<span class="glyphicons remove_2" [attr.aria-label]="UI_BackButton | translate">
	</span>
</a>
